<button
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
    [attr.data-uitype]="'checkbox'"
    [disabled]="disabled()"
    (click)="click()"
    [class.flex]="showTooltip()"
    [class.items-center]="showTooltip()"
    class="bg-transparent  text-left text-dat-grey-900"
    [class.cursor-pointer]="!disabled()"
    [class.cursor-not-allowed]="disabled()"
>
    <span
        [datiqTemplateMd]="currentLabel()"
        [attr.data-uitype]="'checkbox-label'"
        [attr.data-styletarget]="id() + '-label'"
        [class.inline-block]="showTooltip()"
        [class.mr-2]="showTooltip()"
        class="iq-md-icon-label checkbox-label"
    ></span>
    @if(showTooltip()){
    <span class="inline-block">
        <iq-tooltip-tooltip
            [id]="id() + '-tooltip'"
            [tooltipBody]="tooltipBody()"
            [tooltipHeader]="tooltipHeader()"
            [label]="currentTooltipLabel()"
        ></iq-tooltip-tooltip>
    </span>
    }
</button>
